import { render, staticRenderFns } from "./DoctorClinicMain.vue?vue&type=template&id=d8c2c4b4&"
import script from "./DoctorClinicMain.vue?vue&type=script&lang=js&"
export * from "./DoctorClinicMain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports